import Swiper, {
  Navigation,
  Pagination,
  Thumbs,
  Scrollbar,
  Autoplay,
} from "swiper";

export default function swiper() {
  swiperThumbsGallery();
  swiperCarModelHome();
  swiperCarModelHome2();
  swiperTestimonials();
  swiperAboutCar();
  swiperAutoCategory();
  swiperPopularModels();
  swiperInfrastructure();
  // swiperFilterMobile()
  swiperThreeSteps();
  swipersAutoCards();
  swiperAutoCard();
  swiperCertificate();
  // swiperAutoCardMain();
  swiperNewReviews();
  swiperDriverGift();
  swiperDriverServis();
  swiperNewFeedback();

  window.addEventListener("resize", swiperPopularModels);
}

export function swiperNewFeedback() {
  let thumbsSwiper = null;

  if (document.querySelector(".js-new-feedback-swiper")) {
    thumbsSwiper = new Swiper(".js-new-feedback-swiper", {
      modules: [Navigation, Pagination],
      spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      //watchSlidesProgress: true,

      pagination: {
        el: ".new-feedback__swiper-pagination",
        clickable: true,
      },

      navigation: {
        nextEl: ".new-feedback__swiper-next",
        prevEl: ".new-feedback__swiper-prev",
      },

    });
  }

  return thumbsSwiper;
}

function swiperThumbsGallery() {
  if (document.querySelector("#thumbsSwiper")) {
    const thumbsSwiper = new Swiper("#thumbsSwiper", {
      spaceBetween: 30,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
    });

    const swiper2 = new Swiper("#swiperMain", {
      modules: [Navigation, Thumbs],
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: thumbsSwiper,
      },
    });
  }
}

export function swiperThumbsPswp() {
  let thumbsSwiper = null;

  if (document.querySelector(".pswp_thumbs")) {
    thumbsSwiper = new Swiper(".pswp_thumbs", {
      spaceBetween: 30,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
    });
  }

  return thumbsSwiper;
}

function swiperAboutCar() {
  if (document.querySelector("#thumbsSwiperCar")) {
    const thumbsSwiper = new Swiper("#thumbsSwiperCar", {
      spaceBetween: 5,
      slidesPerView: 6,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        577: {
          slidesPerView: "auto",
          spaceBetween: 10,
        },
      },
    });

    const swiper2 = new Swiper("#swiperMainCar", {
      modules: [Navigation, Thumbs],
      spaceBetween: 15,
      slidesPerView: 1.05,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        577: {
          slidesPerView: "auto",
          spaceBetween: 10,
        },
      },
      thumbs: {
        swiper: thumbsSwiper,
      },
    });
  }

  // const swiperAboutCar = new Swiper(".about-car-main__swiper", {
  //   modules: [Navigation],
  //   spaceBetween: 10,
  //   loop: true,
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  // });
}



  function swiperCarModelHome() {
    if (1) {
      window.swiper2 = new Swiper("#sliderCarModel", {
        modules: [Scrollbar, Autoplay],
        spaceBetween: 0,
        enabled: false,
        freeMode: true,
        speed: 4000,
        autoplay: {
          delay: 0.1,
        },
        loop: false,
        resistance: false,
        resistanceRatio: 0,
        slidesPerView:'auto',
        disableOnInteraction: false,
        centeredSlides: true,
        on: {
          touchEnd: function() {
            console.log('', window.swiper2.translate);
            setTimeout(() => {
              window.swiper2.autoplay.start();
            }, 100);
          }
        },

        // slidesPerView: "auto",
        direction: "horizontal",
        breakpoints: {
          // when window width is >= 767px
          769: {
            spaceBetween: 0,
            enabled:true,
            loop: true,
          },
        },
        /* scrollbar: {
          el: ".swiper-scrollbar-model",
          draggable: true,
          dragSize: 200,
        }, */
      });
    }

    // if ( document.querySelector('.page__body_moscow') ) {
    //   window.swiper2 = new Swiper("#sliderCarModel", {
    //     modules: [Scrollbar, Autoplay],
    //     spaceBetween: 0,
    //     loop: true,
    //     slidesPerView:'auto',
    //     disableOnInteraction: false,
    //     centeredSlides: true,
    //
    //     slidesPerView: "auto",
    //     direction: "horizontal",
    //     breakpoints: {
    //       // when window width is >= 767px
    //       769: {
    //
    //       },
    //     },
    //     /* scrollbar: {
    //       el: ".swiper-scrollbar-model",
    //       draggable: true,
    //       dragSize: 200,
    //     }, */
    //   });
    // }

  }




function swiperCarModelHome2() {
  const swiper2 = new Swiper("#sliderCarModel-2", {
    modules: [Scrollbar],
    spaceBetween: 10,
    slidesPerView: "auto",
    direction: "horizontal",
    breakpoints: {
      // when window width is >= 767px
      767: {
        spaceBetween: 60,
      },
    },
  });
}

function swiperAutoCategory() {
  const swiper2 = new Swiper("#sliderAutoCategory", {
    modules: [Scrollbar],
    //spaceBetween: 60,
    slidesPerView: "auto",
    direction: "horizontal",
    breakpoints: {
      // when window width is >= 767px
      320: {
        slidesPerView: 2,
      },
      576: {
        slidesPerView: 3,
      },
      767: {
        slidesPerView: 4,
      },
      1000: {
        slidesPerView: 6,
        //spaceBetween: 20,
      },
      1400: {
        //spaceBetween: 60,
        slidesPerView: 6,
      },
    },
    /*     navigation: {
      nextEl: "#sliderAutoCategoryButtonNext",
      prevEl: "#sliderAutoCategoryButtonPrev",
    }, */
    scrollbar: {
      el: ".swiper-scrollbar-category",
      draggable: true,
      dragSize: 200,
    },
  });
}

function swiperPopularModels() {
  document.querySelectorAll(".popular-models")?.forEach((slider) => {
    let swiper = new Swiper(slider.querySelector("#sliderPopularModels"), {
      modules: [Navigation, Pagination],
      spaceBetween: 30,
      slidesPerView: "auto",
      centeredSlides: false,
      //loop: true,
      //enabled: false,
      navigation: {
        nextEl: slider.querySelector("#sliderPopularModelsBtnNext"),
        prevEl: slider.querySelector("#sliderPopularModelsBtnPrev"),
      },
      pagination: {
        el: slider.querySelector("#sliderPopularModelsPagination"),
      },
      breakpoints: {
        769: {
          //enabled: true,
          spaceBetween: 30,
          //loop: true,
        },
        320: {
          //enabled: false,
          spaceBetween: 30,
          //loop: false,
        },
      },
    });
  });

  // let swiper = new Swiper("#sliderPopularModels", {
  //   modules: [Navigation, Pagination],
  //   spaceBetween: 20,
  //   slidesPerView: "auto",
  //   centeredSlides: false,
  //   enabled: false,
  //   loop: true,
  //   navigation: {
  //     nextEl: "#sliderPopularModelsBtnNext",
  //     prevEl: "#sliderPopularModelsBtnPrev",
  //   },
  //   pagination: {
  //     el: "#sliderPopularModelsPagination",
  //   },
  //   breakpoints: {
  //     769: {
  //       enabled: true,
  //     },
  //     767: {
  //       spaceBetween: 24,
  //     },
  //     391: {
  //       centeredSlides: false,
  //     },
  //     320: {
  //       centeredSlides: true,
  //     },

  //   },
  // });
}

function swiperInfrastructure() {
  const swiper = new Swiper("#sliderInfrastructure", {
    modules: [Autoplay],
    spaceBetween: 30,
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    speed: 2000,
    autoplay: {
      delay: 2000,
    },
    pauseOnMouseEnter: true,
    breakpoints: {
      767: {
        spaceBetween: 70,
      },
    },
  });
}

function swiperThreeSteps() {
  const swiperThreeSteps = new Swiper("#swiperThreeSteps", {
    modules: [Navigation],
    //spaceBetween: 60,
    slidesPerView: 1,
    direction: "horizontal",
    breakpoints: {
      576: {
        slidesPerView: 1,
      },
      1350: {
        slidesPerView: 3,
      },
    },
    navigation: {
      nextEl: "#sliderStepsButtonNext",
      prevEl: "#sliderStepsButtonPrev",
    },
    /* scrollbar: {
      el: '.swiper-scrollbar-category',
      draggable: true,
      dragSize: 200
    } */
  });
}

function swiperTestimonials() {
  const swiper = new Swiper("#sliderTestimonials", {
    modules: [Navigation, Pagination],
    spaceBetween: 30,
    slidesPerView: 1,
    navigation: {
      nextEl: "#sliderTestimonialsButtonNext",
      prevEl: "#sliderTestimonialsButtonPrev",
    },
    pagination: {
      el: "#sliderTestimonialsPagination",
    },
    breakpoints: {
      767: {
        slidesPerView: "auto",
      },
      1350: {
        slidesPerView: 3,
      },
    },
  });
}

function swiperAutoCard() {
  let swiper = null;

  if (document.querySelector(".auto-card__swiper")) {
    swiper = new Swiper(".auto-card__swiper", {
      modules: [Navigation, Pagination],
      spaceBetween: 16,
      slidesPerView: 1,
      grabCursor: true,
      pagination: {
        el: ".auto-card__swiper-pagination",
        modifierClass: "auto-card__swiper-pagination_custom ",
        clickable: true,
      },
      on: {
        slideChangeTransitionStart() {
          this.$el[0].classList.add("auto-card__swap");
        },
        slideChangeTransitionEnd() {
          this.$el[0].classList.remove("auto-card__swap");
        },
        touchStart() {
          this.$el[0].classList.add("auto-card__swap");
        },
        touchEnd() {
          this.$el[0].classList.remove("auto-card__swap");
        },
      },
      // on: {
      //   slideChange: function() {
      //     let slider = this.$el[0];
      //     let more = slider.querySelector(".auto-card__slider-more-wrapper");
      //     if (this.activeIndex+1 == this.slides.length) {
      //       more.classList.add('auto-card__slider-more-wrapper_show');
      //     } else {
      //       more.classList.remove('auto-card__slider-more-wrapper_show');
      //     }
      //   }
      // }
    });

    if (Array.isArray(swiper) && swiper.length) {
      swiper.forEach((slider) => {
        if (slider.el.parentElement.classList.contains("auto-card--slider")) {
          slider.pagination.bullets.forEach((bullet, index) => {
            bullet.addEventListener("mouseover", () => {
              slider.slideTo(index, 0);
            });
          });

          slider.el.addEventListener("mouseleave", () => {
            slider.slideTo(0, 0);
          });
        }
      });
    }
  }
}

function swiperAutoCardMain() {
  let swiper = null;

  if (document.querySelector(".auto-card-main__swiper")) {
    swiper = new Swiper(".auto-card-main__swiper", {
      modules: [Navigation, Pagination],
      spaceBetween: 16,
      slidesPerView: 1,
      pagination: {
        el: ".auto-card-main__swiper-pagination",
        modifierClass: "auto-card-main__swiper-pagination_custom ",
      },
      // on: {
      //   slideChange: function() {
      //     let slider = this.$el[0];
      //     let more = slider.querySelector(".auto-card__slider-more-wrapper");
      //     if (this.activeIndex+1 == this.slides.length) {
      //       more.classList.add('auto-card__slider-more-wrapper_show');
      //     } else {
      //       more.classList.remove('auto-card__slider-more-wrapper_show');
      //     }
      //   }
      // }
    });
  }
}

// function swiperFilterMobile() {

//   const menuButton = document.querySelector('.menu-button');
//   const openMenu = function () {
//     swiper.slidePrev();
//   };

//   const swiper = new Swiper('#swiperMenu', {
//     slidesPerView: 'auto',
//     initialSlide: 1,
//     resistanceRatio: 0,
//     slideToClickedSlide: true,
//     direction: 'vertical',
//     on: {
//       slideChangeTransitionStart: function () {
//         const slider = this;
//         if (slider.activeIndex === 0) {
//           menuButton.classList.add('cross');
//           // required because of slideToClickedSlide
//           menuButton.removeEventListener('click', openMenu, true);
//         } else {
//           menuButton.classList.remove('cross');
//         }
//       },
//       slideChangeTransitionEnd: function () {
//         const slider = this;
//         if (slider.activeIndex === 1) {
//           menuButton.addEventListener('click', openMenu, true);
//         }
//       },
//     },
//   });

// }

function swiperCertificate() {
  const swiperHolidays = new Swiper(".certificate-holiday__cards-slider", {
    modules: [Navigation, Pagination],
    spaceBetween: 16,
    slidesPerView: "auto",
    pagination: {
      el: ".certificate-holiday__cards-slider__pagination",
    },
    navigation: {
      nextEl: ".certificate-holiday__cards-slider__btn_next",
      prevEl: ".certificate-holiday__cards-slider__btn_prev",
    },
    breakpoints: {
      769: {
        enabled: false,
      },
    },
  });

  const swiperHolidaysCards = new Swiper(
    ".certificate-holiday__forwho-slider",
    {
      modules: [Navigation, Pagination],
      spaceBetween: 16,
      slidesPerView: "auto",
      pagination: {
        el: ".certificate-holiday__forwho-slider__pagination",
      },
      navigation: {
        nextEl: ".certificate-holiday__forwho-slider__btn_next",
        prevEl: ".certificate-holiday__forwho-slider__btn_prev",
      },
      breakpoints: {
        1025: {
          enabled: false,
        },
      },
    }
  );
}

function swipersAutoCards() {
  const wrappers = document.querySelectorAll(".auto-card__slider");
  wrappers.forEach((node) => {
    const imgElem = node.querySelector(".auto-card__slider-img");
    const baseImgUrl = imgElem.getAttribute("src");
    const buttonElements = node.querySelectorAll(
      ".auto-card__slider-trigger-btn"
    );
    // const moreElem = node.querySelector('.auto-card__slider-more-wrapper');
    node.addEventListener("mouseout", (e) => {
      e.stopPropagation();
      if (e.target.classList.contains("auto-card__slider-trigger")) {
        imgElem.setAttribute("src", baseImgUrl);
        buttonElements.forEach((button) =>
          button.classList.remove("auto-card__slider-trigger-btn_active")
        );
        buttonElements[0].classList.add("auto-card__slider-trigger-btn_active");
        // moreElem.classList.remove('auto-card__slider-more-wrapper_show')
      }
    });
    node.addEventListener("mouseover", (e) => {
      e.stopPropagation();
      if (e.target.classList.contains("auto-card__slider-trigger")) {
        const { url } = e.target.dataset;
        imgElem.setAttribute("src", url);
        const currentActiveButton = e.target.querySelector(
          ".auto-card__slider-trigger-btn"
        );
        buttonElements.forEach((button) =>
          button.classList.remove("auto-card__slider-trigger-btn_active")
        );
        currentActiveButton.classList.add(
          "auto-card__slider-trigger-btn_active"
        );
        // if (currentActiveButton === buttonElements[buttonElements.length - 1]) {
        //   moreElem.classList.add('auto-card__slider-more-wrapper_show')
        // } else {
        //   moreElem.classList.remove('auto-card__slider-more-wrapper_show')
        // }
      }

      // Чтобы при наведении на визуальную кнопку не сбрасывало текущее фото
      if (e.target.classList.contains("auto-card__slider-trigger-btn")) {
        const triggerNode = e.target.parentNode;
        const { url } = triggerNode.dataset;
        imgElem.setAttribute("src", url);
        buttonElements.forEach((button) =>
          button.classList.remove("auto-card__slider-trigger-btn_active")
        );
        e.target.classList.add("auto-card__slider-trigger-btn_active");

        // if (e.target === buttonElements[buttonElements.length - 1]) {
        //   moreElem.classList.add('auto-card__slider-more-wrapper_show')
        // } else {
        //   moreElem.classList.remove('auto-card__slider-more-wrapper_show')
        // }
      }
    });
  });
}

function swiperNewReviews() {
  const swiperNewReviews = new Swiper(".new-reviews__swiper", {
    modules: [Navigation, Pagination],
    slidesPerView: "auto",
    navigation: {
      nextEl: ".new-reviews__swiper-next",
      prevEl: ".new-reviews__swiper-prev",
    },
  });
}

function swiperDriverGift() {
  const sliderDriverGiftBlock = document.querySelector("#sliderDriverGift");
  if (sliderDriverGiftBlock) {
    const sliderDriverGift = new Swiper(sliderDriverGiftBlock, {
      modules: [Navigation, Pagination],
      slidesPerView: "auto",
      spaceBetween: 24,
      loop: true,
      navigation: {
        nextEl: sliderDriverGiftBlock.querySelector(
          "#sliderPopularModelsBtnNext"
        ),
        prevEl: sliderDriverGiftBlock.querySelector(
          "#sliderPopularModelsBtnPrev"
        ),
      },
      pagination: {
        el: sliderDriverGiftBlock.querySelector(
          "#sliderPopularModelsPagination"
        ),
      },
    });
  }
}

function swiperDriverServis() {
  const slider = new Swiper(".js-driver-servis", {
    slidesPerView: "auto",
    enabled: true,
    spaceBetween: 24,
    breakpoints: {
      1025: {
        enabled: false,
      },
    },
  });
}
